import { FC } from "react";
import { ToolbarProps } from "react-big-calendar";

const CalendarToolbarEmpty: FC<ToolbarProps> = ({ onView, onNavigate, label, view }) => {
  return (<></>);
}

export default CalendarToolbarEmpty;